(function () {
  'use strict';

  document.querySelectorAll('.cogbox').forEach(initCogBox);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.cogbox').forEach(initCogBox);
  });

  function initCogBox(root) {
    if (root.dataset.cogboxInitialized === 'true') return;
    root.dataset.cogboxInitialized = 'true';
    initReveal(root);
    initTabs(root);
    initAccordion(root);
    initStepper(root);
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal(root) {
    const els = root.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting) {
            const el = entry.target;
            const delay = (i % 4) * 80;
            setTimeout(() => el.classList.add('is-visible'), delay);
            io.unobserve(el);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );
    els.forEach((el) => io.observe(el));
  }

  /* ---------- Plans tabs ---------- */
  function initTabs(root) {
    const wrap = root.querySelector('[data-tabs]');
    if (!wrap) return;
    const tabs = wrap.querySelectorAll('.cb-plans__tab');
    const panels = root.querySelectorAll('[data-tab-panel]');

    const activateTab = (tab, moveFocus = false) => {
      const target = tab.getAttribute('data-tab-target');

      tabs.forEach((item) => {
        const isActive = item === tab;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', String(isActive));
        item.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        const isActive = panel.getAttribute('data-tab-panel') === target;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      if (moveFocus) tab.focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab));
      tab.addEventListener('keydown', (event) => {
        let nextIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (index + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        activateTab(tabs[nextIndex], true);
      });
    });
  }

  /* ---------- Benefits accordion ---------- */
  function initAccordion(root) {
    const list = root.querySelector('[data-accordion]');
    if (!list) return;
    const items = list.querySelectorAll('.cb-accordion-item');

    const setItemState = (item, isOpen) => {
      const trigger = item.querySelector('.cb-accordion-item__trigger');
      const panel = item.querySelector('.cb-accordion-item__panel');
      item.classList.toggle('is-open', isOpen);
      trigger.setAttribute('aria-expanded', String(isOpen));
      panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0px';
    };

    items.forEach((item) => {
      const trigger = item.querySelector('.cb-accordion-item__trigger');
      setItemState(item, item.classList.contains('is-open'));

      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        items.forEach((accordionItem) => setItemState(accordionItem, false));
        if (!isOpen) setItemState(item, true);
      });
    });

    window.addEventListener('resize', () => {
      items.forEach((item) => {
        if (item.classList.contains('is-open')) setItemState(item, true);
      });
    });
  }

  /* ---------- How It Works — scroll-linked stepper ---------- */
  function initStepper(root) {
    const rail = root.querySelector('[data-stepper]');
    const fill = root.querySelector('[data-stepper-fill]');
    if (!rail || !fill) return;
    const items = rail.querySelectorAll('[data-stepper-item]');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach((i) => i.classList.add('is-active'));
      fill.style.width = '100%';
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('is-active');
        });
        const activeCount = rail.querySelectorAll('[data-stepper-item].is-active').length;
        fill.style.width = (activeCount / items.length) * 100 + '%';
      },
      { threshold: 0.6, rootMargin: '0px 0px -20% 0px' }
    );
    items.forEach((el) => io.observe(el));
  }
})();
